import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { EntityType } from '../../shared/share';
import { NgChartsModule } from 'ng2-charts';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SubmitMedicalEvidenceComponent } from '../../submit-medical-evidence/submit-medical-evidence.component';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { PatientsData, TeamMember } from '@app/modules/lps-member-login/models/commonmodel';
import { CdkDragDrop, DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MemberCardComponent } from "../../member-card/member-card.component";
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { NotificationService } from '../../shared/services/notifications.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CountUpPipe } from '../../shared/pipes/count-up.pipe';
import { Subject } from 'rxjs';
import { NoDataFoundComponent } from "../../shared/no-data-found/no-data-found.component";
import { LoaderComponent } from "../../shared/loader/loader.component";
import { allAdminInsurerResponse } from '@app/modules/lps-member-login/models/phase1models';


interface KanbanColumn {
  title: string;
  members: PatientsData[];
}

@Component({
  selector: 'app-dashboard-member',
  standalone: true,
  imports: [CommonModule, NgChartsModule, DragDropModule, MemberCardComponent, MatFormFieldModule, MatInputModule, FormsModule,
    MatTooltipModule, CountUpPipe, NoDataFoundComponent, LoaderComponent],
  templateUrl: './dashboard-member.component.html',
  styleUrl: './dashboard-member.component.scss'
})
export class DashboardMemberComponent implements OnChanges {
  activeTab: string = 'overview';
  enumEntityType = EntityType;
  isDataLoading: boolean = false;
  selectedOption: any;
  showQuickFilters: boolean = false;
  searchAgent: any;
  filteredAgents: any[] = [];
  selectedUser: any = null;
  activeMemberId: string | null = null;
  showedUserSelected: any;
  allPatientsList: PatientsData[] = [];
  openRequestsHoverTrigger$: Subject<void> = new Subject<void>();
  inProgressHoverTrigger$: Subject<void> = new Subject<void>();
  moreInfoRequestedHoverTrigger$: Subject<void> = new Subject<void>();
  completedRequestsHoverTrigger$: Subject<void> = new Subject<void>();
  dashboardData: any;
  searchQuery: string = '';
  agentsList: any[] = [];
  patientsListTemp: PatientsData[] = [];
  patientsList: PatientsData[] = [];
  kanbanColumns: KanbanColumn[] = [
    { title: 'Open', members: [] },
    { title: 'In Progress', members: [] },
    { title: 'More Info Requested', members: [] },
    { title: 'Completed', members: [] }
  ];
  isSidebarExpanded: boolean = false;
  searchExpanded = false;
  connectedDropListsIds: string[] = [];
  @Input() maxDisplayed: number = 6;
  displayedTeamMembers: TeamMember[] = [];
  remainingMembersCount: number = 0;
  showPopover = false;

  constructor(private dialog: MatDialog, private memberService: MemberInsurerServiceService, private restService: MemberInsurerRestService,
    private notification: NotificationService
  ) { }

  ngOnInit() {
    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      console.log('Sidebar expanded state:', expanded);
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });
    this.getDashboardCounts();
    this.memberService.refreshDashboard$.subscribe(() => {
      this.getMemberList();
      this.getDashboardCounts();
    });
    this.connectedDropListsIds = this.kanbanColumns.map(c => c.title);
    this.memberService.tabChanged$.subscribe(tab => {
      this.activeTab = tab;
    });
    this.getMemberList();
    this.getAllAgents();
  }

  ngOnChanges() {
    this.updateDisplayedMembers();
  }

  onCloseQuickFilter() {
    this.showQuickFilters = false;
    this.selectedOption = null;
    this.searchAgent = null;
    this.selectedUser = null;
    this.filteredAgents = this.agentsList;
    this.clearFilters();
  }

  toggleQuickFilters(): void {
    this.showQuickFilters = !this.showQuickFilters;
  }

  onAgentSearch(): void {
    this.selectedOption = null;
    this.clearFilters();
    const query = this.searchAgent.toLowerCase();
    this.filteredAgents = this.agentsList.filter(agent => {
      const fullName = `${agent.firstName} ${agent.lastName}`.toLowerCase();
      return fullName.includes(query);
    });
  }

  selectUser(user: any): void {
    if (this.selectedUser === user.userId) {
      this.clearFilters();
    } else {
      this.selectedUser = user.userId;
      this.selectedOption = null;
      this.onAvatarClick(user, 'filter');
    }
  }

  getAllAgents() {
    this.agentsList = [];
    const loginUserId = this.memberService.getLoginUserId();

    this.restService.getAllAgentList().subscribe(
      // next:(value: any)=>{
      //   if(value){

      //       const selfUserIndex = value.findIndex((user: any) => user.userId === loginUserId);
      //       if (selfUserIndex > -1) {
      //        const [selfUser] = value.splice(selfUserIndex, 1); // Remove from current position
      //        value.unshift(selfUser); // Add at the beginning

      //         this.agentsList = value;
      //      this.filteredAgents = value;
      //      this.updateDisplayedMembers();
      //    }

      //   }

      // },
      // error:(err)=>{}
    // }
      res => {
        if (res) {
          // Find the current user without modifying their name
          const selfUserIndex = res.findIndex((user: any) => user.userId === loginUserId);

          if (selfUserIndex > -1) {
            const [selfUser] = res.splice(selfUserIndex, 1); // Remove from current position
            res.unshift(selfUser); // Add at the beginning
          }

          this.agentsList = res;
          this.filteredAgents = res;
          this.updateDisplayedMembers();
        }
      },
      err => {
        this.agentsList = [];
      }
    );
  }

  isRotating = false;

  onRefresh() {
    this.isRotating = true;
    this.getMemberList();
    // Stop animation after 1s (match CSS animation duration)
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }

  onAvatarClick(member: TeamMember, from: string): void {
    if (this.activeMemberId === member.userId || this.showedUserSelected === member.userId) {
      this.activeMemberId = null;
      this.showedUserSelected = null;
      this.patientsList = [...this.allPatientsList];
    } else {
      console.log(this.showedUserSelected, from)
      if (from == 'user') {
        this.showedUserSelected = member.userId;
        this.activeMemberId = member.userId;
      }
      if (from != 'user')
        this.showedUserSelected = null;
      this.patientsList = this.allPatientsList.filter(patient =>
        patient.serviceRequest?.assignedProvider?.id === member.userId
      );
    }
    this.updateKanbanColumns();
  }

  getAssignedAgentFullName(member: any) {
    return member.firstName + " " + member.lastName;
  }

  onSearchInputChange() {
    if (this.searchAgent.trim()) {
      this.selectedOption = null; // Deselect both radio buttons
    }
    this.onAgentSearch(); // Your existing search logic
  }

  onSelfClick() {
    let userId = this.memberService.getLoginUserId();
    // this.activeMemberId = userId;
    // this.selectedOption = userId;
    this.patientsList = this.allPatientsList.filter(patient =>
      patient.serviceRequest?.assignedProvider?.id === userId
    );
    this.updateKanbanColumns();
  }

  onOpenRequestsHover(): void {
    this.openRequestsHoverTrigger$.next();
  }

  onInProgressHover(): void {
    this.inProgressHoverTrigger$.next();
  }

  onMoreInfoRequestedHover(): void {
    this.moreInfoRequestedHoverTrigger$.next();
  }

  onCompletedRequestsHover(): void {
    this.completedRequestsHoverTrigger$.next();
  }

  getDashboardCounts() {
    this.dashboardData = [];
    let userId = this.memberService.getOrg();
    this.restService.getDashboardDataProvider(userId).subscribe(res => {
      if (res) {
        this.dashboardData = res;
      }
    }, err => {
      this.dashboardData = [];
    })
  }

  onSearch() {
    const query = this.searchQuery.trim().toLowerCase();
    let filteredList = [...this.allPatientsList];

    if (query) {
      filteredList = this.allPatientsList.filter(patient =>
        patient.firstName.toLowerCase().includes(query) ||
        patient.lastName.toLowerCase().includes(query) ||
        (patient.serviceRequest?.status && patient.serviceRequest.status.toLowerCase().includes(query)) ||
        (patient.serviceRequest?.assignedProvider &&
          `${patient.serviceRequest.assignedProvider.firstName} ${patient.serviceRequest.assignedProvider.lastName}`.toLowerCase().includes(query))
      );
    }
    this.patientsList = filteredList;
    this.updateKanbanColumns();
  }

  hasRequests(): boolean {
    return this.kanbanColumns.some(column => column.members.length > 0);
  }

  getMemberList() {
    this.isDataLoading = true;
    const id = this.memberService.getLoginUserId();

    this.restService.getAllMemberList(id).subscribe({
      next: (response: PatientsData[]) => {
        if (response.length > 0) {
          response = response
            .filter((member: { createdon: any }) => member.createdon)
            .sort((a: { createdon: string | number | Date }, b: { createdon: string | number | Date }) =>
              new Date(b.createdon).getTime() - new Date(a.createdon).getTime()
            );

          const flattenedPatients: PatientsData[] = [];
          for (const patient of response) {
            if (patient.serviceRequest?.length) {
              for (const req of patient.serviceRequest) {
                flattenedPatients.push({
                  ...patient,
                  serviceRequest: req
                });
              }
            } else {
              flattenedPatients.push({ ...patient, serviceRequest: null });
            }
          }
          this.allPatientsList = flattenedPatients;
          this.patientsList = [...this.allPatientsList];
          this.updateKanbanColumns();
        }
        this.isDataLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
      }
    });
  }

  updateKanbanColumns() {
    this.kanbanColumns.forEach(col => col.members = []);

    for (const record of this.patientsList) {
      if (record.serviceRequest) {
        const status = record.serviceRequest.status;
        if (status === 'REQUESTED') {
          this.kanbanColumns.find(col => col.title === 'Open')?.members.push(record);
        } else if (status === 'INPROGRESS') {
          this.kanbanColumns.find(col => col.title === 'In Progress')?.members.push(record);
        } else if (status === 'RECEIVED') {
          this.kanbanColumns.find(col => col.title === 'Completed')?.members.push(record);
        } else if (status === 'MORE_INFO_REQUESTED') {
          this.kanbanColumns.find(col => col.title === 'More Info Requested')?.members.push(record);
        }
      }
    }
  }

  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (!this.searchExpanded) {
      this.searchQuery = '';
      this.onSearch();
    }
  }

  drop(event: CdkDragDrop<PatientsData[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const draggedPatient = event.previousContainer.data[event.previousIndex];

      if (event.container.id === 'Completed') {
        const hasUnfulfilledRequests = draggedPatient.serviceRequest?.some((req: { status: string; documents: string | any[]; }) =>
          req.status === 'REQUESTED' && (!req.documents || req.documents.length === 0)
        );

        if (hasUnfulfilledRequests) {
          this.notification.showNotification('Please submit medical evidence before completing this request.', 'error');
          return;
        }
      }

      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);

      if (event.container.id === 'Ongoing') {
        draggedPatient.status = 'ONGOING';
      } else if (event.container.id === 'Completed') {
        draggedPatient.status = 'RECEIVED';
      }
    }
  }

  getColumnClass(title: string): string {
    switch (title) {
      case 'Pending': return 'kanban-pending';
      case 'Completed': return 'kanban-completed';
      case 'Ongoing': return 'kanban-ongoing';
      default: return 'kanban-total';
    }
  }

  getAvatarVariant(index: number): string {
    const variants = ['variant-purple', 'variant-indigo', 'variant-green'];
    return variants[index % variants.length];
  }

  updateDisplayedMembers() {
    if (!this.agentsList || this.agentsList.length === 0) {
      this.displayedTeamMembers = [];
      this.remainingMembersCount = 0;
      return;
    }
    this.displayedTeamMembers = this.agentsList.slice(0, this.maxDisplayed);
    this.remainingMembersCount = this.agentsList.length - this.displayedTeamMembers.length;
  }

  getInitials(member: TeamMember): string {
    if (member.firstName == 'Self') {
      return member.actualName;
    } else {
      const firstInitial = member.firstName ? member.firstName.charAt(0).toUpperCase() : '';
      const lastInitial = member.lastName ? member.lastName.charAt(0).toUpperCase() : '';
      return firstInitial + lastInitial;
    }
  }

  getAvatarColorClass(index: number): string {
    const colorClasses = ['blue-light', 'blue-medium', 'blue-dark'];
    return colorClasses[index % colorClasses.length];
  }


  togglePopover() {
    this.showPopover = !this.showPopover;
  }

  clearFilters() {
    this.activeMemberId = null;
    this.showedUserSelected = null;
    this.patientsList = [...this.allPatientsList];
    this.updateKanbanColumns();
    this.showPopover = false;
    if (this.showQuickFilters && (this.selectedUser || this.selectedOption)) {
      if (this.selectedUser) {
        this.selectedUser = null;
      } else {
        this.showQuickFilters = false;
        this.selectedOption = null;
      }
    }
  }

  optionChanged() {
    this.patientsList = [...this.allPatientsList];
    this.updateKanbanColumns();
  }

  get hiddenAgents() {
    return this.agentsList.slice(this.maxDisplayed);
  }

  getCircularStyle(index: number, totalMembers: number) {
    if (totalMembers === 0) return {};

    const angleIncrement = (2 * Math.PI) / totalMembers;
    const angle = index * angleIncrement - (Math.PI / 2);

    const containerWidth = 160;
    const containerHeight = 160;
    const avatarSize = 32;

    const radius = (Math.min(containerWidth, containerHeight) / 2) - (avatarSize / 2);

    const centerX = containerWidth / 2;
    const centerY = containerHeight / 2;

    const x = centerX + radius * Math.cos(angle);
    const y = centerY + radius * Math.sin(angle);

    return {
      top: `${y}px`,
      left: `${x}px`,
    };
  }

  openMedicalEvidence() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(SubmitMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  goToMembersTab() {
    this.activeTab = 'members';
  }
}